import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import parse from 'html-react-parser';

import { GlobalFormats } from '../../classess/main/globalFormats';

import UserCompanyAdd from './UserCompanyAdd';
import UserCompanyCustomerAdd from './UserCompanyCustomerAdd';

import { User } from '../../classess/user/user';
import { Role } from '../../classess/role/role';
import { UserCompany } from '../../classess/userCompany/userCompany';
import { Company } from '../../classess/company/company';
import { Customer } from '../../classess/customer/customer';
import { RoleUser } from '../../classess/role/roleUser';
import { UserCompanyCustomer } from '../../classess/userCompanyCustomer/userCompanyCustomer';

import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, isValidEmail, isValidPhoneNumber, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection, awaitDelayAsync,
} from '../../helpers/main';
import { UserService } from '../../services/users/UserService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, colors, icons, images, labels, messages, timers } = settings;

const currentMethod = 'UserEditDetails';

export default function UserEditDetails({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const { id, } = useParams();

    const dtUserCompaniesId = 'dtUserCompanies';
    const dtUserCompaniesProcess = {
        addCustomer: 'userCompanyCustomerAdd',
        delete: 'userCompanyDelete',
        details: 'userCompanyDetails',
    };
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        addCompany: false,
        back: false,
    });

    const [user, setUser] = useState({ ...User?.getClass({}, false), passwordConfirm: '', });
    const [roles, setRoles] = useState([Role?.class({}, false)]);
    const [roleUserBefore, setRoleUserBefore] = useState(RoleUser?.class({}, false));
    const [roleUserAfter, setRoleUserAfter] = useState(RoleUser?.class({}, false));
    const [userCompanies, setUserCompanies] = useState([UserCompany?.class({}, false)]);
    const [companies, setCompanies] = useState([Company?.getClass({}, false)]);
    const [userLength] = useState(User?.minMaxLength(false));

    const isMount = useRef(true);
    const [errors, setErrors] = useState({
        firstName: '', lastName: '', email: '', phoneNumber: '', department: '', position: '', password: '', passwordConfirm: '', role: '',
    });
    const [showPassword, setShowPassword] = useState(false);

    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModalUserCompanies: false,
        showModalUserCompanyCustomers: false,
        languageObj: languageObj,
        dtUserCompaniesId: dtUserCompaniesId,
        dtUserCompaniesRowId: 0,
        dtUserCompaniesProcess: dtUserCompaniesProcess,
        companies: [Company?.getClass({}, false)],
        customers: [Customer?.getClass({}, false)],
        user: User?.getClass({}, false),
        userCompany: UserCompany?.class({}, false),
        userCompanies: [UserCompany?.class({}, false)],
        userCompanyCustomer: UserCompanyCustomer?.getClass({}, false),
        userCompanyCustomers: [UserCompanyCustomer?.getClass({}, false)],
    });
    const controls = {
        buttons: {
            addCompany: {
                defaultClass: 'btn btn-info shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddCompany',
            },
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
        },
        dataTables: {
            userCompanies: {
                inputs: {
                    search: {
                        id: `${dtUserCompaniesId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtUserCompaniesId}_length select`,
                        defaultClass: '',
                    },
                },
            },
        },
        icons: {
            addCompany: {
                id: 'iconAddCompany',
                defaultClass: icons?.fasFa?.list,
            },
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            department: {
                id: 'inputDepartment',
            },
            email: {
                id: 'inputEmail',
            },
            firstName: {
                id: 'inputFirstName',
            },
            lastName: {
                id: 'inputLastName',
            },
            password: {
                id: 'inputPassword',
            },
            passwordConfirm: {
                id: 'inputPasswordConfirm',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
            },
            position: {
                id: 'inputPosition',
            },
        },
        selects: {
            role: {
                id: 'selRole'
            },
        },
        spiners: {
            addCompany: {
                id: 'spAddCompany',
                defaultClass: '',
            },
            save: {
                id: 'spSave',
                defaultClass: '',
            }
        },
    };
    //#endregion methods

    //#region methods
    //#region users
    const editUser = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editUser';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true, showLoading: true, }));

            //#region user (update)
            response = await UserService.update({
                auth: auth,
                id: user.id,
                data: user,
                roleUserBefore: { ...roleUserBefore, userId: id },
                roleUserAfter: { ...roleUserAfter, userId: id, },
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            setUser(User?.getClass(response?.result?.user, false));
            setRoleUserBefore(RoleUser?.class(response?.result?.roleUser || {}, false));
            setRoleUserAfter(RoleUser?.class(response?.result?.roleUser || {}, false));
            //#endregion user (update)

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const deleteUserCompany = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'deleteUserCompany';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.company?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };

            const swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data(usercompany)
                        preConfirmResponse = await UserService.deleteCompanyAssignmentAsync({
                            auth: auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return;
                        //#endregion delete data (usercompany)

                        //#region delete datatable (usercompany)
                        $(`#${dtUserCompaniesId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        //#endregion delete datatable (usercompany)

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}`;
                    } catch (ex) {
                        //#region error
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                        //#endregion error
                    }
                    return preConfirmResponse;
                },
            };

            const swalresult = await Swal?.fire({ ...swalProperties });
            if (swalresult?.isConfirmed && swalresult?.value) {
                response = swalresult?.value;
            } else if (swalresult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getAddUserCompany = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getAddUserCompany';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, addCompany: true, showLoading: true, }));

            e?.preventDefault?.();

            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            setModalObj(prev => ({
                ...prev,
                showModalUserCompanies: true,
                user: user,
                companies: companies,
                userCompany: { ...UserCompany?.class({}, false), userId: user.id },
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, addCompany: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getAddUserCompanyCustomer = async ({
        e = {},
        _id = 0,
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getAddUserCompanyCustomer';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true, }));

            e?.preventDefault?.();

            //#region get data (general)
            response = await UserService.getGeneralDataAsync({
                auth: auth,
                id: id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const companiesData = (response?.result?.companies || [])?.sort((a, b) => a?.name < b?.name ? -1 : (a?.name > b?.name ? 1 : 0));
            let customersData = (response?.result?.customers || [])?.sort((a, b) => a?.name < b?.name ? -1 : (a?.name > b?.name ? 1 : 0));
            const userData = response?.result?.user || {};
            const userCompaniesData = response?.result?.userCompanies || [];

            let userCompaniesDataId_ = userCompaniesData?.find(item => item?.id === parseInt(_id)) || {};
            const userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
            const userCompanyCustomersData_ = userCompanyCustomersData.filter(item => item?.companyId === userCompaniesDataId_?.companyId);
            const userCompanyCustomersId_ = new Set(userCompanyCustomersData_.map(item => item?.customerId));
            customersData = customersData.filter(item => !userCompanyCustomersId_.has(item?.id));
            //#endregion get data (users)

            const userCompanyData = userCompaniesData.filter(({ id }) => id === parseInt(_id))[0] || UserCompany?.class({}, false);

            setModalObj(prev => ({
                ...prev,
                dtUserCompaniesRowId: rowId,
                showModalUserCompanyCustomers: true,
                companies: companiesData,
                customers: customersData,
                user: userData,
                userCompany: userCompanyData,
                userCompanies: userCompaniesData,
                userCompanyCustomers: userCompanyCustomersData,
                userCompanyCustomer: { ...UserCompanyCustomer?.getClass({}, false), companyId: userCompanyData.companyId, userId: userCompanyData.userId, },
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getEditDetailsUserCompanyCustomers = async ({
        e = {},
        _id = 0,
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getEditDetailsUserCompanyCustomers';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            setProcess(prev => ({ ...prev, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = `${backend?.urls?.userCompanyCustomers}/${_id}`
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    languageId: languageObj?.id,
                });
            }
        }
        return response;
    }
    //#endregion users

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (general)
                response = await UserService.getGeneralDataAsync({
                    auth: auth,
                    id: id,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const companiesData = response?.result?.companies || [];
                setCompanies(companiesData);

                const rolesData = response?.result?.roles || [];
                setRoles(rolesData);
                // TODO: check userRole can be one or many?
                // const roleUserData = RoleUser?.class(response?.result?.roleUser || {}, false);
                const roleUserData = RoleUser?.class(response?.result?.roleUser?.[0] || {}, false);
                setRoleUserAfter(roleUserData);
                setRoleUserBefore(roleUserData);

                const userData = response?.result?.user || {};
                setUser({ ...userData, passwordConfirm: '' });
                const userCompaniesData = response?.result?.userCompanies || [];
                setUserCompanies(userCompaniesData);
                const userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
                //#endregion get data (users)

                //#region set datatable
                if (!isUndNullEmp({ data: userCompaniesData, subMethod: currentMethod })?.result &&
                    userCompaniesData.length > 0) {
                    response = setDataInDataTable({
                        userCompaniesData: userCompaniesData,
                        userCompanyCustomersData: userCompanyCustomersData,
                        companiesData: companiesData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtUserCompaniesId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.code[languageObj?.id], width: '15%', },
                    { title: labels?.description?.[languageObj?.id], width: '65%', },
                    { title: labels?.customers?.[languageObj?.id], width: '15%', className: 'text-right', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                // lengthChange: true,
                lengthChange: false,
                info: false,
                paging: false,
                searching: false,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtUserCompaniesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtUserCompaniesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtUserCompaniesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case dtUserCompaniesProcess.addCustomer:
                            getAddUserCompanyCustomer({ e: e, _id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case dtUserCompaniesProcess.details:
                            getEditDetailsUserCompanyCustomers({ e: e, _id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case dtUserCompaniesProcess.delete:
                            deleteUserCompany({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        userCompaniesData = [],
        userCompanyCustomersData = [UserCompanyCustomer?.getClass({}, false)],
        companiesData = [Company?.getClass({}, false)],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowData = [];
            //#endregion variables

            //#region process
            userCompaniesData.forEach((userCompany) => {
                //#region variables
                const modelUserCompany = UserCompany?.class(userCompany, false);
                const companyData = {
                    email: companiesData.filter(({ id, }) => id === modelUserCompany.companyId)[0]?.email || '',
                    secundaryId: companiesData.filter(({ id, }) => id === modelUserCompany.companyId)[0]?.secundaryId || '',
                    name: companiesData.filter(({ id, }) => id === modelUserCompany.companyId)[0]?.name || '',
                    customersCount: userCompanyCustomersData.filter(({ companyId, }) => companyId === modelUserCompany.companyId)?.length || 0,
                };
                //#endregion variables

                const processButtons = [
                    {
                        isVisible: true,
                        showDivider: false,
                        isEnabled: true,
                        methodName: dtUserCompaniesProcess.addCustomer,
                        icon: icons?.fasFa?.plusCircle,
                        label: `${labels?.add?.[languageObj?.id]}`
                    },
                    {
                        isVisible: true,
                        showDivider: false,
                        isEnabled: true,
                        methodName: dtUserCompaniesProcess.details,
                        icon: icons?.fasFa?.list,
                        label: `${labels?.details[languageObj?.id]}`
                    },
                    {
                        isVisible: true,
                        showDivider: false,
                        isEnabled: !(companyData.customersCount > 0),
                        methodName: dtUserCompaniesProcess.delete,
                        icon: icons?.fasFa?.trash,
                        label: `${labels?.delete[languageObj?.id]}`
                    },
                ];
                rowData.push([
                    companyData.secundaryId,
                    companyData.name,
                    companyData.customersCount,
                    getProcessButtons({
                        id: modelUserCompany.id,
                        description: companyData.name,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: false,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtUserCompaniesId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;

            if (isUndNullEmp({ data: user, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    firstName: thisFieldRequired,
                    lastName: thisFieldRequired,
                    email: thisFieldRequired,
                    phoneNumber: thisFieldRequired,
                    department: thisFieldRequired,
                    position: thisFieldRequired,
                    password: thisFieldRequired,
                    passwordConfirm: thisFieldRequired,
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.firstName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, firstName: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.lastName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, lastName: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.email, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, email: thisFieldRequired }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: user?.email, subMethod: currentMethod })?.result && !isValidEmail({ data: user?.email })) {
                setErrors(prev => ({ ...prev, email: `${messages?.youMustEnterValidEmail[languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.phoneNumber, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, phoneNumber: thisFieldRequired }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: user?.phoneNumber, subMethod: currentMethod })?.result && !isValidPhoneNumber({ data: user?.phoneNumber })) {
                setErrors(prev => ({ ...prev, phoneNumber: `${messages?.youMustEnterValidPhoneNumber[languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.department, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, department: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: user?.position, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, position: thisFieldRequired }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result &&
                user?.password?.length < settings.passwords.minLength) {
                setErrors(prev => ({ ...prev, password: `${messages?.youMustEnterValidPassword[languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result &&
                user?.passwordConfirm?.length < settings.passwords.minLength) {
                setErrors(prev => ({ ...prev, passwordConfirm: `${messages?.youMustEnterValidPasswordConfirm[languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: user?.password, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: user?.passwordConfirm, subMethod: currentMethod })?.result &&
                user?.password !== user?.passwordConfirm) {
                setErrors(prev => ({
                    ...prev,
                    password: `${messages?.passwordAndPasswordConfirmNotMatch[languageObj?.id]}.`,
                    passwordConfirm: `${messages?.passwordAndPasswordConfirmNotMatch[languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                firstName: '', lastName: '', email: '', phoneNumber: '', department: '', position: '', password: '', passwordConfirm: '', role: ''
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const gotoBack = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'gotoBack';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });
            window.location.href = backend?.urls?.users;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount) return;
            setProcess(prev => ({ ...prev, back: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad', });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.settings?.settings} process={app?.views?.users?.user} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.user?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.users}>{labels?.users?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.user?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={settings?.html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.users?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.user}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.edit?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-warning text-dark px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                                <i className={icons?.fasFa?.userEdit} /> {labels?.edit?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <form onSubmit={(e) => editUser({ e: e, subMethod: 'form' })}>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.firstName?.[languageObj?.id]}
                                                                </small>
                                                                <input autoFocus
                                                                    id={controls?.inputs?.firstName?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.firstName}
                                                                    onChange={(e) => setUser({ ...user, firstName: e?.target?.value })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, firstName: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.firstName?.id, })?.result && !isUndNullEmp({ data: user?.firstName, subMethod: controls?.inputs?.firstName?.id, })?.result ?
                                                                        user.firstName : ''}
                                                                    placeholder={labels?.firstName?.[languageObj?.id]}
                                                                    title={labels?.firstName?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.firstName)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.lastName?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.lastName?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.lastName}
                                                                    onChange={(e) => setUser({ ...user, lastName: e?.target?.value })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, lastName: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.lastName?.id, })?.result && !isUndNullEmp({ data: user?.lastName, subMethod: controls?.inputs?.lastName?.id, })?.result ?
                                                                        user.lastName : ''}
                                                                    placeholder={labels?.lastName?.[languageObj?.id]}
                                                                    title={labels?.lastName?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.lastName)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.envelope} mr-1`} /> {labels?.email?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.email?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.email}
                                                                    onChange={(e) => setUser({ ...user, email: e?.target?.value })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.email?.id, })?.result && !isUndNullEmp({ data: user?.email, subMethod: controls?.inputs?.email?.id, })?.result ?
                                                                        user.email : ''}
                                                                    placeholder={labels?.email?.[languageObj?.id]}
                                                                    title={labels?.email?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.email)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.mobileAlt} mr-1`} /> {labels?.phoneNumber?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.phoneNumber?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.phoneNumber}
                                                                    onChange={(e) => setUser({ ...user, phoneNumber: e?.target?.value })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, phoneNumber: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.phoneNumber?.id, })?.result && !isUndNullEmp({ data: user?.phoneNumber, subMethod: controls?.inputs?.phoneNumber?.id, })?.result ?
                                                                        user.phoneNumber : ''}
                                                                    placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                                                    title={labels?.phoneNumber?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.phoneNumber)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.department?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.department?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.department}
                                                                    onChange={(e) => setUser({ ...user, department: e?.target?.value })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, department: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.department?.id, })?.result && !isUndNullEmp({ data: user?.department, subMethod: controls?.inputs?.department?.id, })?.result ?
                                                                        user.department : ''}
                                                                    placeholder={labels?.department?.[languageObj?.id]}
                                                                    title={labels?.department?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.department)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.idBadge} mr-1`} /> {labels?.position?.[languageObj?.id]}
                                                                </small>
                                                                <input id={controls?.inputs?.position?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.position}
                                                                    onChange={(e) => setUser({ ...user, position: e?.target?.value })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, position: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.position?.id, })?.result && !isUndNullEmp({ data: user?.position, subMethod: controls?.inputs?.position?.id, })?.result ?
                                                                        user.position : ''}
                                                                    placeholder={labels?.position?.[languageObj?.id]}
                                                                    title={labels?.position?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.position)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                                                    <small className='text-muted text-uppercase font-weight-bold'>
                                                                        <i className={`${icons?.fasFa?.lock} mr-1`} /> {labels?.password?.[languageObj?.id]}
                                                                    </small>
                                                                    <span style={{ cursor: 'pointer', fontSize: '1.2rem' }} className='text-primary' onClick={() => setShowPassword(!showPassword)}>
                                                                        <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                                    </span>
                                                                </div>
                                                                <input id={controls?.inputs?.password?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.password}
                                                                    onChange={(e) => setUser({ ...user, password: e?.target?.value, })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, password: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.password?.id, })?.result && !isUndNullEmp({ data: user?.password, subMethod: controls?.inputs?.password?.id, })?.result ?
                                                                        user.password : ''}
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    placeholder={labels?.password?.[languageObj?.id]}
                                                                    title={labels?.password?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.password)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                                                    <small className='text-muted text-uppercase font-weight-bold'>
                                                                        <i className={`${icons?.fasFa?.lock} mr-1`} /> {labels?.passwordConfirm?.[languageObj?.id]}
                                                                    </small>
                                                                    <span style={{ cursor: 'pointer', fontSize: '1.2rem' }} className='text-primary' onClick={() => setShowPassword(!showPassword)}>
                                                                        <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                                    </span>
                                                                </div>
                                                                <input id={controls?.inputs?.passwordConfirm?.id}
                                                                    className='form-control bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    maxLength={userLength.max.password}
                                                                    onChange={(e) => setUser({ ...user, passwordConfirm: e?.target?.value, })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, passwordConfirm: '' }))}
                                                                    readOnly={process?.save || process?.addCompany || process?.back}
                                                                    value={!isUndNullEmp({ data: user, subMethod: controls?.inputs?.passwordConfirm?.id, })?.result && !isUndNullEmp({ data: user?.passwordConfirm, subMethod: controls?.inputs?.passwordConfirm?.id, })?.result ?
                                                                        user.passwordConfirm : ''}
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    placeholder={labels?.passwordConfirm?.[languageObj?.id]}
                                                                    title={labels?.passwordConfirm?.[languageObj?.id]} />
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.passwordConfirm)}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <div className='form-group mb-4'>
                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                    <i className={`${icons?.idCard} mr-1`} /> {labels?.role?.[languageObj?.id]}
                                                                </small>
                                                                <select id={controls?.selects?.role?.id}
                                                                    className='custom-select bg-light border-0 shadow-sm'
                                                                    style={{ borderRadius: '5px' }}
                                                                    value={!isUndNullEmp({ data: roleUserAfter?.roleId, subMethod: controls?.selects?.role?.id, })?.result ?
                                                                        roleUserAfter?.roleId : ``
                                                                    }
                                                                    onChange={(e) => setRoleUserAfter({ ...roleUserAfter, roleId: e?.target?.value, })}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, role: '' }))}
                                                                    disabled={process?.save || process?.addCompany || process?.back}
                                                                    placeholder={labels?.country?.[languageObj?.id]}
                                                                    title={labels?.country?.[languageObj?.id]}>
                                                                    <option key={`nothing`} value={``}>{messages?.selectRole?.[languageObj?.id]}</option>
                                                                    {roles.map((role) => <option key={role.id} value={role.id}>{role.name}</option>)}
                                                                </select>
                                                                <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.role)}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-md-12 d-flex flex-wrap justify-content-end' style={{ gap: '0.5rem' }}>
                                                            <button id={controls?.buttons?.addCompany.id}
                                                                className={process?.addCompany ? `${controls?.buttons?.addCompany.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addCompany.defaultClass}
                                                                disabled={process?.save || process?.addCompany || process?.back}
                                                                style={{ borderRadius: '5px' }}
                                                                title={labels?.addCompanyAbr?.[languageObj?.id]}
                                                                onClick={(e) => getAddUserCompany({ e: e, subMethod: controls?.buttons?.addCompany.id, })}
                                                                type='button'>
                                                                {process?.addCompany ? (
                                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                ) : (
                                                                    <i id={controls?.icons?.addCompany?.id} className={`${controls?.icons?.addCompany?.defaultClass}`} />
                                                                )} {labels?.addCompanyAbr?.[languageObj?.id]}
                                                            </button>
                                                            <button id={controls?.buttons?.save?.id}
                                                                className={process?.save ? `${controls?.buttons?.save?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.save?.defaultClass}
                                                                disabled={process?.save || process?.addCompany || process?.back}
                                                                style={{ borderRadius: '5px' }}
                                                                title={labels?.save?.[languageObj?.id]}
                                                                type='submit'>
                                                                {process?.save ? (
                                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                ) : (
                                                                    <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass}`} />
                                                                )} {labels?.save?.[languageObj?.id]}
                                                            </button>
                                                            <button id={controls?.buttons?.back?.id}
                                                                disabled={process?.save || process?.addCompany || process?.back}
                                                                className={process?.back ? `${controls?.buttons?.back?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.back?.defaultClass}
                                                                style={{ borderRadius: '5px' }}
                                                                onClick={(e) => gotoBack({ e: e, subMethod: controls?.buttons?.back?.id })}
                                                                title={labels?.back?.[languageObj?.id]}
                                                                type='button'>
                                                                {process?.back ? (
                                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                ) : (
                                                                    <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass}`} />
                                                                )} {labels?.back?.[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>

                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.fileAlt} text-secondary`} style={{ fontSize: '12px' }} />
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.companiesAccess?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtUserCompaniesId} languageObj={languageObj} />
                                            </div>

                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModalUserCompanies && (
                <UserCompanyAdd modalObj={modalObj}
                    setModalObj={setModalObj}
                    userCompanies={userCompanies}
                    setUserCompanies={setUserCompanies} />
            )}

            {modalObj?.showModalUserCompanyCustomers && (
                <UserCompanyCustomerAdd modalObj={modalObj}
                    setModalObj={setModalObj}
                    userCompanies={userCompanies}
                    setUserCompanies={setUserCompanies} />
            )}
        </div>
    )
}